import { Pipe, PipeTransform } from '@angular/core';
import { CoreConfigService } from '@core/services/config.service';

interface ApiTranslation {
  cn?: string;
  de?: string;
  en?: string;
  es?: string;
  fr?: string;
  it?: string;
  nl?: string;
  pl?: string;
  pt?: string;
  ru?: string;
}

@Pipe({
  name: 'apiTranslate',
  pure: false
})
export class ApiTranslatePipe implements PipeTransform {

  private _config: any;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private _coreConfigService: CoreConfigService
  ) {
    this._coreConfigService.config.subscribe((config: any) => this._config = config);
  }

  /**
   * Transform
   *
   * @param translations Object that contains translations from API
   * @returns Translation that match current language
   */
  transform(translations: string): string {
    if (!translations) return '';

    const parsed: ApiTranslation = JSON.parse(translations); 
    let translation: string = parsed[this._config.app.appLanguage];

    if (!translation) translation = parsed['fr'];

    return translation && translation !== '' ? translation : '';
  }

}
